import { Box, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { AlertBanner } from '@/components/alerts/AlertBanner';

import { Header } from './Header';
import { Sidebar } from './Sidebar';

export function AppLayout() {
  return (
    <Box sx={{ display: 'flex' }}>
      <Header />
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3, minWidth: 0 }}>
        <Toolbar />
        <AlertBanner />
        <Outlet />
      </Box>
    </Box>
  );
}
